//import wrapPromise from "../api/wrapPromise"

import API from '../api'

const baseUrl = process.env.REACT_APP_BASE_PATH 

// const getItems = data => {
//     return data.reduce( (acc, item) => { 
         
//         if (item.statusConvenio === 'A') {
//             acc.push(item)
//         } else if (item.statusPlano === 'A') {
//             acc.push(item)
//         } else if (item.idEspecialidade) {
//             acc.push(item)
//         } else if (item.idAgenda) {
//             acc.push(item)
//         } 
        
//         return acc

//     }, [])
// }

export const getPlanos = params => { 
    
    const body = {
        // aliasEmpresa: 'ACOR',
        // hash: 'ad655c0a14276899ce6b401843115d18', 
        funcao: 'getPlano',
        ...params, 
        
    }
    
    return API.post( baseUrl + '/plano.php', body)
}

const apiPlanos = {
    getPlanos
}

export default apiPlanos